import { ApiResponse } from "./ApiResponse";

export class ServiceResponse<T> {

  public success: boolean
  public response: Response
  public data: T

  constructor(apiResponse: ApiResponse<unknown>, data: T) {
    this.success = apiResponse.success
    this.response = apiResponse.response
    this.data = data
  }
}
